// TODO move to a common library
export function navigate(url: string): void {
  if (url.startsWith('tel:') || url.startsWith('mailto:')) {
    window.open(url, '_self')
  } else if (window.ENV_CONFIG.EVENT_BASED_NAVIGATION) {
    newNavigationEvent(url)
  } else if (url.startsWith('http')) {
    window.open(url, '_blank')
  } else {
    window.location.assign(url)
  }
}

/* istanbul ignore next */
function newNavigationEvent(url: string): void {
  try {
    if (isIE11()) {
      const params = { bubbles: true, cancelable: false, detail: { url } }
      const evt = document.createEvent('CustomEvent')
      evt.initCustomEvent('appNavigation', params.bubbles, params.cancelable, params.detail)
      window.dispatchEvent(evt)
    } else {
      window.dispatchEvent(
        new CustomEvent('appNavigation', {
          bubbles: true,
          detail: {
            url
          }
        })
      )
    }
  } catch (_e) {
    window.location.assign(url)
  }
}

/* istanbul ignore next */
export function isIE11(): boolean {
  // The Document type does not define the property documentMode. This property is only set on IE11, therefore
  // a cast to any is required in order to access the property without getting typescript errors.
  // See https://stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return !!(document as any).documentMode
}
